import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent } from "vue"

import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import useHook from './useHook'
import CustomerLabelCascaderText from './CustomerLabelCascaderText.vue'

const __default__ = { name: 'CustomerLabelCascader' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  appId: {
    type: String,
    validator: (value: string) => {
      return ['cos_fbu', 'cos_ofbu', 'cos_lbu'].includes(value)
    },
    default: 'cos_lbu'
  },
  type: {
    type: String,
    default: 'search'
  },
  view: Boolean,
  onlyCommon: {
    type: Boolean,
    required: false,
    default: true
  }
},
  setup(__props) {

const { t } = useI18n()

const props = __props
const { customerLabelEnum } = useHook(props.appId)

const vaildCustomerLabelEnum = ref()

const attrs = computed(() => ({
  type: props.type,
  changeOnSelect: true,
  multiple: props.type && props.appId === 'cos_lbu', // 只有 search 类型 且为 cos_lbu 才支持多选
  maxTagCount: props.appId === 'cos_lbu' ? 'responsive' : undefined,
  fieldNames: props.appId === 'cos_lbu' ? { label: 'name', value: 'id' } : { label: 'label', value: 'id' }
}))

watch(
  () => customerLabelEnum.value,
  () => {
    vaildCustomerLabelEnum.value = disabledOptions(customerLabelEnum.value)
  },
  { immediate: true }
)

function disabledOptions(data: any[]) {
  const result: any[] = []

  for (const node of data) {
    if (props.onlyCommon && node.labelType === 1) {
      node.disabled = true
    }

    if (node.status === 0) { // && (!props.onlyCommon || node.labelType === 0)
      result.push(node)
    }
    if (node.children) {
      node.children = disabledOptions(node.children)
    }
  }
  return result

  // for (const node of data) {
  //   node.disabled = node.status === 1

  //   if (node.children) {
  //     disabledOptions(node.children)
  //   }
  // }
}

return (_ctx: any,_cache: any) => {
  const _component_CosCascader = _resolveComponent("CosCascader")!

  return (__props.view)
    ? (_openBlock(), _createBlock(CustomerLabelCascaderText, _mergeProps({ key: 0 }, attrs.value, {
        lastLeval: true,
        appId: __props.appId,
        view: __props.view
      }), null, 16, ["appId", "view"]))
    : (_openBlock(), _createBlock(_component_CosCascader, _mergeProps({ key: 1 }, attrs.value, {
        options: vaildCustomerLabelEnum.value,
        placeholder: _unref(t)('common.pleaseSelect'),
        allowClear: ""
      }), null, 16, ["options", "placeholder"]))
}
}

})